jQuery.feature_import("js-react-sandbox",
  () => import("./sandbox.js"),
  mod => mod.feature_js_react_sandbox
);